// Shared enums mirroring the backend contract (values must match exactly).

// Mirrors C# DknApplicationType exactly — JSON binds enums by number, so the
// values must line up or a body bound to [FromBody] DknApplicationType resolves
// to the wrong member.
export enum ApplicationType {
    Smartstore = 0,
    Jasper = 1,
    Office365 = 2,
    MinButtik = 3,
    All = 4,
}

export enum MappingMode {
    Add = '1',
    Edit = '2',
}

export enum ServiceAvailability {
    undefined = 0,
    available = 1,
    notAvailable = 2,
    notFound = 3,
}
